module.exports = __webpack_public_path__ + "img/9791170280750.6e51d875.jpg";